import React from 'react';

function Loader(props: any) {
    return (
        <div id="loader" className={`w-[56px] lg:w-[76px] aspect-square rounded-[50%] border-[3px] border-l-primary border-t-primary animate-spin ${props.className ?? ""}`}>
        </div>
    );
}

export default Loader;
